var _style, _g, _polygon, _polygon2, _polygon3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcommercesolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{opacity:0.28;}\r\n\t.st4{fill:#1761B0;}\r\n\t.st5{fill:#221B22;}\r\n\t.st6{fill:#564C54;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:#EDE0C3;}\r\n\t.st9{fill:#F77659;}\r\n\t.st10{fill:#E33D15;}\r\n\t.st11{fill:#F0F0F0;}\r\n\t.st12{fill:#EBB12B;}\r\n\t.st13{fill:#D38400;}\r\n\t.st14{fill:#AF0C15;}\r\n\t.st15{fill:#3639D9;}\r\n\t.st16{fill:#4B71F8;}\r\n\t.st17{fill:#B92F14;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.5454,
    y1: 1445.5999,
    x2: 147.5454,
    y2: 1060.3108,
    gradientTransform: "matrix(0.4041 0.5247 0.887 -0.6831 -827.0271 920.4833)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0812,
    style: {
      stopColor: "#F9FBFD",
      stopOpacity: 0.1013
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1869,
    style: {
      stopColor: "#E9F0F8",
      stopOpacity: 0.2332
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#CEDEEE",
      stopOpacity: 0.3819
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4352,
    style: {
      stopColor: "#A9C4E2",
      stopOpacity: 0.5429
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5723,
    style: {
      stopColor: "#78A3D1",
      stopOpacity: 0.7139
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7139,
    style: {
      stopColor: "#3F7CBE",
      stopOpacity: 0.8906
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#1761B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "470.77,6.97 172.22,236.89 259.89,244.14 470.77,81.73  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.3397,
    y1: 1350.8965,
    x2: 369.3397,
    y2: 1004.0717,
    gradientTransform: "matrix(0.4041 0.5247 0.887 -0.6831 -827.0271 920.4833)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0812,
    style: {
      stopColor: "#F9FBFD",
      stopOpacity: 0.1013
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1869,
    style: {
      stopColor: "#E9F0F8",
      stopOpacity: 0.2332
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#CEDEEE",
      stopOpacity: 0.3819
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4352,
    style: {
      stopColor: "#A9C4E2",
      stopOpacity: 0.5429
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5723,
    style: {
      stopColor: "#78A3D1",
      stopOpacity: 0.7139
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7139,
    style: {
      stopColor: "#3F7CBE",
      stopOpacity: 0.8906
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#1761B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "509.42,162.6 210.88,392.52 298.55,399.77 509.42,237.37  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.5275,
    y1: 1220.2278,
    x2: 155.5275,
    y2: 847.8204,
    gradientTransform: "matrix(0.4256 0.5526 0.887 -0.6831 -805.2849 948.5669)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    style: {
      stopColor: "#1761B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6592,
    style: {
      stopColor: "#76A2D0",
      stopOpacity: 0.6358
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#C0D4EA",
      stopOpacity: 0.3283
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9412,
    style: {
      stopColor: "#EEF3F9",
      stopOpacity: 0.1096
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2.58,508.28 352.71,238.63 321.52,172.76 2.58,418.39  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 252.95,
    cy: 481.39,
    rx: 205.02,
    ry: 11.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M405.03,72.15v390.42c0,12.24-9.92,22.16-22.16,22.16H188.45c-6.15,0-11.71-2.5-15.72-6.54 c-3.98-4.01-6.43-9.52-6.43-15.61V72.15c0-12.24,9.92-22.16,22.16-22.16h194.42c3.62,0,7.03,0.87,10.05,2.41 C400.11,56.07,405.03,63.53,405.03,72.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M166.29,171.81h-0.61c-4.14,0-7.49-3.36-7.49-7.49v-36.59c0-4.14,3.36-7.49,7.49-7.49h0.61V171.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M405.03,158.31h0.5c3.39,0,6.13-2.75,6.13-6.13v-29.74c0-3.39-2.75-6.13-6.13-6.13h-0.5V158.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M166.29,230.39h-0.61c-4.14,0-7.49-3.36-7.49-7.49v-36.6c0-4.14,3.36-7.49,7.49-7.49h0.61V230.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M393.97,70.81v393.1c0,5.4-4.37,9.76-9.76,9.76H187.1c-4.03,0-7.49-2.44-8.98-5.94 c-0.5-1.18-0.78-2.47-0.78-3.82V70.81c0-5.39,4.37-9.76,9.76-9.76h197.1c1.36,0,2.65,0.27,3.83,0.77 C391.53,63.33,393.97,66.79,393.97,70.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M377.65,257.62H198.18c-0.71,0-1.29,0.58-1.29,1.29l0,0c0,0.71,0.58,1.29,1.29,1.29h179.47 c0.71,0,1.29-0.58,1.29-1.29l0,0C378.94,258.2,378.37,257.62,377.65,257.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M377.65,268.42H198.18c-0.71,0-1.29,0.58-1.29,1.29l0,0c0,0.71,0.58,1.29,1.29,1.29h179.47 c0.71,0,1.29-0.58,1.29-1.29l0,0C378.94,269,378.37,268.42,377.65,268.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M377.65,124.78h-86.09c-0.71,0-1.29-0.58-1.29-1.29l0,0c0-0.71,0.58-1.29,1.29-1.29h86.09 c0.71,0,1.29,0.58,1.29,1.29l0,0C378.94,124.2,378.37,124.78,377.65,124.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M377.65,135.58h-86.09c-0.71,0-1.29-0.58-1.29-1.29l0,0c0-0.71,0.58-1.29,1.29-1.29h86.09 c0.71,0,1.29,0.58,1.29,1.29l0,0C378.94,135,378.37,135.58,377.65,135.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M377.65,146.37h-86.09c-0.71,0-1.29-0.58-1.29-1.29l0,0c0-0.71,0.58-1.29,1.29-1.29h86.09 c0.71,0,1.29,0.58,1.29,1.29l0,0C378.94,145.8,378.37,146.37,377.65,146.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M377.65,157.17h-86.09c-0.71,0-1.29-0.58-1.29-1.29l0,0c0-0.71,0.58-1.29,1.29-1.29h86.09 c0.71,0,1.29,0.58,1.29,1.29l0,0C378.94,156.6,378.37,157.17,377.65,157.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M377.65,167.97h-86.09c-0.71,0-1.29-0.58-1.29-1.29l0,0c0-0.71,0.58-1.29,1.29-1.29h86.09 c0.71,0,1.29,0.58,1.29,1.29l0,0C378.94,167.4,378.37,167.97,377.65,167.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M377.65,178.77h-86.09c-0.71,0-1.29-0.58-1.29-1.29l0,0c0-0.71,0.58-1.29,1.29-1.29h86.09 c0.71,0,1.29,0.58,1.29,1.29l0,0C378.94,178.2,378.37,178.77,377.65,178.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 276.47,
    y: 352.96,
    className: "st9",
    width: 72.72,
    height: 55.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.06,
    y: 350.2,
    className: "st9",
    width: 77.54,
    height: 9.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.47,
    y: 359.38,
    className: "st10",
    width: 72.72,
    height: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.65,
    y: 350.2,
    className: "st7",
    width: 6.37,
    height: 58.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.64,
    y: 364.11,
    className: "st11",
    width: 6.37,
    height: 44.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.64,
    y: 359.39,
    className: "st8",
    width: 6.37,
    height: 5.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.89,
    y: 296.46,
    transform: "matrix(0.9104 -0.4138 0.4138 0.9104 -110.2358 139.2172)",
    className: "st12",
    width: 72.72,
    height: 55.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.8,
    y: 296.01,
    transform: "matrix(0.9104 -0.4138 0.4138 0.9104 -101.4809 132.6957)",
    className: "st12",
    width: 77.54,
    height: 9.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.16,
    y: 304.55,
    transform: "matrix(0.9104 -0.4138 0.4138 0.9104 -103.8968 134.4971)",
    className: "st13",
    width: 72.72,
    height: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.5,
    y: 293.82,
    transform: "matrix(0.9104 -0.4138 0.4138 0.9104 -109.7757 138.8731)",
    className: "st7",
    width: 6.37,
    height: 58.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.41,
    y: 307.09,
    transform: "matrix(0.9104 -0.4138 0.4138 0.9104 -112.1316 140.642)",
    className: "st11",
    width: 6.37,
    height: 44.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.37,
    y: 304.56,
    transform: "matrix(0.9104 -0.4138 0.4138 0.9104 -103.8947 134.5079)",
    className: "st8",
    width: 6.37,
    height: 5.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 323.79,
    cy: 448.47,
    r: 9.69
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 323.79,
    cy: 448.47,
    r: 6.06
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M261.18,448.47c0,5.35,4.34,9.69,9.69,9.69s9.69-4.34,9.69-9.69s-4.34-9.69-9.69-9.69 S261.18,443.12,261.18,448.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M270.87,454.53c3.34,0,6.06-2.72,6.06-6.06s-2.72-6.06-6.06-6.06s-6.06,2.72-6.06,6.06 S267.53,454.53,270.87,454.53z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M366.17,323.26c-0.47-0.54-1.15-0.85-1.86-0.85H221.38l-2.27-8.32c-0.3-1.08-1.28-1.83-2.4-1.83h-15.46 v4.98h13.56l2.2,8.07c0.01,0.07,0.03,0.15,0.05,0.22l4.47,16.05l0,0l0.69,2.48l5.64,20.23l1.37,4.93l5.45,19.57l1.37,4.93 l4.91,17.64c0.03,0.11,0.06,0.21,0.11,0.31l0,0l0,0l4.23,15.19c2.21,7.91,9.48,13.44,17.7,13.44h75.39 c1.36,0,2.46-1.1,2.46-2.46s-1.1-2.46-2.46-2.46H263c-6.01,0-11.33-4.04-12.95-9.84l-3.45-12.38h105.75 c1.23,0,2.27-0.91,2.44-2.13l2.41-17.32l0.69-4.93l2.73-19.57l0.69-4.93l2.9-20.79c0.21-0.37,0.34-0.79,0.34-1.25 c0-0.21-0.03-0.42-0.08-0.62l2.29-16.43C366.85,324.51,366.64,323.79,366.17,323.26z M350.21,408.25H245.24l-3.38-12.12 c-0.03-0.11-0.07-0.22-0.12-0.32v-0.01l-0.58-2.06h111.07L350.21,408.25z M352.92,388.8H239.79l-5.45-19.57h121.31 L352.92,388.8z M356.34,364.3H232.97l-5.45-19.57h131.54L356.34,364.3z M359.75,339.8h-133.6l-3.47-12.46h138.81 L359.75,339.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M186.15,314.75L186.15,314.75c0,1.38,1.11,2.49,2.49,2.49h17.17v-4.98h-17.17 C187.27,312.26,186.15,313.38,186.15,314.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M264.52,182.17h-53.88c-7.59,0-13.75-6.15-13.75-13.75V131.8c0-7.59,6.15-13.75,13.75-13.75h53.88 c7.59,0,13.75,6.15,13.75,13.75v36.61C278.27,176.01,272.11,182.17,264.52,182.17z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M202.13,167.57l64.44-0.28c0.48-0.87,0.73-2.11,0.83-3.58c0.38-5.45-1.4-14.14-2.27-19.63 c-0.11-0.64-0.2-1.24-0.27-1.78c-0.12-0.92-0.2-1.68-0.2-2.24c-0.02-4.48-3.98-3.69-3.98-3.69 c-6.49,6.42-13.92-3.13-18.22,0.03c0,0-1.85,1.34-6.95,5.96c-5.09,4.63-13.78,7.7-21.18,10.83 c-9.55,4.04-12.24,8.04-12.76,10.8C201.18,166.18,202.13,167.57,202.13,167.57z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M202.13,167.57l64.44-0.28c0.48-0.87,0.73-2.11,0.83-3.58L201.59,164 C201.18,166.18,202.13,167.57,202.13,167.57z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.52,139.14c0,0-1.16-2.81-3.72-1.9c-2.55,0.91-2.28,5.12-2.28,5.12 S237.07,146.2,241.52,139.14z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M242.36,151.81c0.59,0,1.06-0.48,1.06-1.07c-0.03-6.4-4.05-9.85-4.22-9.99 c-0.45-0.38-1.12-0.32-1.5,0.13c-0.38,0.45-0.32,1.12,0.13,1.49c0.15,0.12,3.44,3,3.46,8.38 C241.3,151.34,241.78,151.81,242.36,151.81z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M228.93,143.52c0.25,0,0.5-0.09,0.7-0.27c1.34-1.2,5.3-1.44,7.48-1.31c0.59,0.03,1.09-0.41,1.12-1 s-0.41-1.09-1-1.12c-0.67-0.04-6.59-0.33-9.02,1.85c-0.44,0.39-0.47,1.06-0.08,1.5 C228.35,143.41,228.64,143.53,228.93,143.52z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M238.29,142.71l0.45-2.26c0,0,0.02,0,0.06,0.01l-1.1-1.1c0.6-0.6,5.97-5.83,10.42-5.85 c0.03,0,0.06,0,0.09,0c1.33,0.01,2.45,0.49,3.34,1.41c0.92,0.96,1.21,2.22,0.79,3.44c-0.71,2.04-3.24,3.61-6.61,4.08 c-2.25,0.32-3.94,0.41-5.14,0.42C239.06,142.86,238.34,142.73,238.29,142.71z M239.8,140.54c1.03,0.04,2.85,0,5.6-0.38 c2.81-0.4,4.42-1.57,4.76-2.56c0.14-0.4,0.05-0.75-0.28-1.09c-0.45-0.47-0.99-0.69-1.7-0.7c-0.02,0-0.04,0-0.05,0 C245.43,135.83,241.57,138.9,239.8,140.54z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M236.53,141.71l0.98-2.08c-2.12-0.99-4.16-3.63-4.04-5.22c0.03-0.39,0.19-0.87,1.19-1.16 c0.69-0.2,1.04-0.03,1.26,0.14c1.11,0.85,1.47,3.76,1.44,5.39l2.3,0.05c0.01-0.55,0.05-5.43-2.34-7.26 c-0.64-0.49-1.73-0.98-3.3-0.52c-2.31,0.67-2.77,2.29-2.84,3.19C230.95,137.06,233.82,140.44,236.53,141.71z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M260,167.32l1.91-0.01c-1.92-2.17-3.72-5.52-3.51-10.3c0.28-6.37,4.08-10.68,6.73-12.93 c-0.11-0.64-0.2-1.24-0.27-1.78c-2.85,2.2-7.65,7.01-8,14.63C256.67,161.51,258.18,164.92,260,167.32z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M236.63,146.17c0.48,0,0.91-0.33,1.03-0.81c0.14-0.57-0.21-1.14-0.78-1.28l-4.03-0.98 c-0.57-0.14-1.14,0.21-1.28,0.78c-0.14,0.57,0.21,1.14,0.78,1.28l4.03,0.98C236.46,146.16,236.55,146.17,236.63,146.17z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M232.62,148.52c0.48,0,0.91-0.33,1.03-0.81c0.14-0.57-0.21-1.14-0.78-1.28l-4.03-0.98 c-0.57-0.14-1.14,0.21-1.28,0.78c-0.14,0.57,0.21,1.14,0.78,1.28l4.03,0.98C232.44,148.51,232.53,148.52,232.62,148.52z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M228.6,150.79c0.48,0,0.91-0.33,1.03-0.81c0.14-0.57-0.21-1.14-0.78-1.28l-4.03-0.98 c-0.57-0.14-1.14,0.21-1.28,0.78c-0.14,0.57,0.21,1.14,0.78,1.28l4.03,0.98C228.43,150.78,228.51,150.79,228.6,150.79z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M224.22,152.89c0.48,0,0.91-0.33,1.03-0.81c0.14-0.57-0.21-1.14-0.78-1.28l-4.03-0.98 c-0.57-0.14-1.14,0.21-1.28,0.78c-0.14,0.57,0.21,1.14,0.78,1.28l4.03,0.98C224.05,152.88,224.13,152.89,224.22,152.89z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M219.47,154.68c0.48,0,0.91-0.33,1.03-0.81c0.14-0.57-0.21-1.14-0.78-1.28l-4.03-0.98 c-0.57-0.14-1.14,0.21-1.28,0.78c-0.14,0.57,0.21,1.14,0.78,1.28l4.03,0.98C219.3,154.67,219.38,154.68,219.47,154.68z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "222.75,226.5 215.99,230.06 217.28,222.53 211.81,217.2 219.37,216.1 222.75,209.25  226.13,216.1 233.69,217.2 228.22,222.53 229.51,230.06  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "257.25,226.5 250.48,230.06 251.78,222.53 246.31,217.2 253.86,216.1 257.25,209.25  260.63,216.1 268.18,217.2 262.72,222.53 264.01,230.06  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "291.74,226.5 284.98,230.06 286.27,222.53 280.8,217.2 288.36,216.1 291.74,209.25  295.12,216.1 302.68,217.2 297.21,222.53 298.5,230.06  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "326.24,226.5 319.47,230.06 320.77,222.53 315.3,217.2 322.85,216.1 326.24,209.25  329.62,216.1 337.17,217.2 331.7,222.53 333,230.06  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "358.86,226.5 352.1,230.06 353.39,222.53 347.92,217.2 355.48,216.1 358.86,209.25  362.24,216.1 369.8,217.2 364.33,222.53 365.63,230.06  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M358.52,240.08H216.13c-11.26,0-20.43-9.16-20.43-20.43c0-11.26,9.16-20.43,20.43-20.43h142.39 c11.26,0,20.43,9.16,20.43,20.43C378.94,230.92,369.78,240.08,358.52,240.08z M216.13,201.22c-10.17,0-18.44,8.27-18.44,18.44 s8.27,18.44,18.44,18.44h142.39c10.17,0,18.44-8.27,18.44-18.44s-8.27-18.44-18.44-18.44H216.13z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M393.97,70.81v20.72H177.34V70.81c0-5.39,4.37-9.76,9.76-9.76h197.1c1.36,0,2.65,0.27,3.83,0.77 C391.53,63.33,393.97,66.79,393.97,70.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M342.27,80.58H229.04c-5.71,0-10.39-4.68-10.39-10.39V68.5c0-5.71,4.68-10.39,10.39-10.39h113.23 c5.71,0,10.39,4.68,10.39,10.39v1.69C352.66,75.9,347.99,80.58,342.27,80.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M317.69,70.63h-75.21c-1.41,0-2.55-1.15-2.55-2.55v-0.42c0-1.41,1.15-2.55,2.55-2.55h75.21 c1.41,0,2.55,1.15,2.55,2.55v0.42C320.25,69.48,319.1,70.63,317.69,70.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M339.82,67.68c0,1.83-1.48,3.32-3.32,3.32s-3.32-1.48-3.32-3.32s1.48-3.32,3.32-3.32 S339.82,65.85,339.82,67.68z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M395.58,143.56l17.84,40.66c1.16,2.64,4.23,3.84,6.87,2.68l40.66-17.84c2.64-1.16,3.84-4.23,2.68-6.87 l-17.84-40.66c-1.16-2.64-4.23-3.84-6.87-2.68l-40.66,17.84C395.62,137.85,394.42,140.93,395.58,143.56z M422.69,135.72 c-1.63,1.15-3.87,0.25-4.23-1.74c-0.18-0.98,0.26-2.03,1.08-2.61c1.63-1.15,3.87-0.25,4.23,1.74 C423.95,134.1,423.51,135.14,422.69,135.72z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M411.11,153.85c-1.96-4.47-0.2-8.29,3.62-9.97c3.82-1.68,7.82-0.38,9.78,4.09 c1.98,4.51,0.2,8.29-3.62,9.97C417.07,159.61,413.08,158.36,411.11,153.85z M429.7,137.75l6.09-2.67l-6.16,32.78l-6.09,2.67 L429.7,137.75z M419.4,150.21c-1.06-2.41-2.17-2.79-2.96-2.44c-0.79,0.35-1.27,1.42-0.21,3.83s2.17,2.79,2.96,2.44 C419.98,153.7,420.46,152.63,419.4,150.21z M434.81,157.63c-1.96-4.47-0.2-8.29,3.62-9.97c3.82-1.68,7.82-0.38,9.78,4.09 c1.98,4.5,0.2,8.29-3.62,9.97C440.78,163.4,436.79,162.14,434.81,157.63z M443.1,154c-1.06-2.41-2.17-2.79-2.96-2.44 c-0.79,0.35-1.27,1.42-0.21,3.83s2.17,2.79,2.96,2.44C443.68,157.48,444.16,156.41,443.1,154z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M424.3,113.3c-2.74-12.9-9.72-27.58-18.68-39.28c-0.18-0.24-0.37-0.48-0.56-0.73v2.29 c9.3,12.38,15.59,26.81,17.96,38c0.98,4.62,1.3,8.64,1,11.82c-0.24,2.44-0.84,4.38-1.8,5.7c-0.37,0.51-0.79,0.93-1.26,1.25 c-0.71,0.47-1.53,0.74-2.48,0.79c-0.07,0.43-0.03,0.89,0.13,1.32c1.15-0.08,2.18-0.42,3.08-1.03c0.59-0.4,1.11-0.91,1.56-1.52 c1.21-1.65,1.93-4.06,2.13-7.1C425.59,121.61,425.24,117.73,424.3,113.3z M405.06,125.25C391.4,108.35,372.18,58.63,368.9,50 c-0.02-0.07-0.05-0.13-0.07-0.19c0.29,0.06,0.57,0.12,0.86,0.19h4.85c-2.13-0.72-4.34-1.29-6.62-1.69 c-0.23-0.04-0.47,0.04-0.62,0.23c-0.15,0.18-0.19,0.43-0.11,0.65c0.05,0.14,0.15,0.41,0.31,0.82 c2.88,7.64,23.24,60.92,37.56,77.28c1.34,1.53,2.62,2.73,3.83,3.55c0.38,0.25,0.75,0.49,1.11,0.72l1.47-0.65 c-0.6-0.34-1.21-0.73-1.85-1.16C408.2,128.78,406.67,127.24,405.06,125.25z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M147,101.32h-39.8c-0.66,0-1.2-0.54-1.2-1.2V67.39c0-0.66,0.54-1.2,1.2-1.2H147c0.66,0,1.2,0.54,1.2,1.2 v32.74C148.2,100.79,147.66,101.32,147,101.32z"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M135.85,99.92l3.7,7.4c0.15,0.3,0.59,0.27,0.7-0.05l2.41-7.35H135.85z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M135.53,89.96c-0.02,0-0.04,0-0.05,0l-21.45-3.62c-0.14-0.02-0.24-0.13-0.27-0.27l-1.41-9.27 c-0.01-0.09,0.01-0.19,0.07-0.26s0.15-0.11,0.24-0.11h25.55c0.1,0,0.19,0.04,0.25,0.12s0.09,0.17,0.07,0.27l-2.69,12.89 C135.81,89.86,135.68,89.96,135.53,89.96z M114.36,85.74l20.92,3.53l2.55-12.2h-24.78L114.36,85.74z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M137.32,80.82C137.31,80.82,137.31,80.82,137.32,80.82l-24.13-0.7c-0.15,0-0.26-0.13-0.26-0.28 s0.12-0.26,0.28-0.26l24.12,0.7c0.15,0,0.27,0.13,0.26,0.28C137.58,80.7,137.46,80.82,137.32,80.82z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M136.22,85.37c-0.01,0-0.02,0-0.03,0l-22.59-2.21c-0.15-0.01-0.26-0.15-0.24-0.29 c0.01-0.15,0.14-0.26,0.29-0.24l22.59,2.21c0.15,0.01,0.26,0.15,0.24,0.29C136.47,85.27,136.36,85.37,136.22,85.37z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M138.22,77.07c-0.02,0-0.05,0-0.07-0.01c-0.17-0.04-0.28-0.21-0.24-0.39l1.02-4.51 c0.03-0.15,0.16-0.25,0.31-0.25h4.3c0.18,0,0.32,0.14,0.32,0.32s-0.14,0.32-0.32,0.32h-4.04l-0.96,4.26 C138.5,76.97,138.37,77.07,138.22,77.07z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M144.87,73.08h-3.2c-0.43,0-0.78-0.35-0.78-0.78v-0.13c0-0.43,0.35-0.78,0.78-0.78h3.2 c0.43,0,0.78,0.35,0.78,0.78v0.13C145.65,72.73,145.3,73.08,144.87,73.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M134.83,93.06h-19.71c-0.18,0-0.32-0.14-0.32-0.32s0.14-0.32,0.32-0.32h19.45l0.64-2.85 c0.04-0.17,0.21-0.28,0.39-0.24c0.17,0.04,0.28,0.21,0.24,0.39l-0.7,3.1C135.11,92.96,134.98,93.06,134.83,93.06z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M121.65,96.28c-0.96,0-1.75-0.78-1.75-1.75c0-0.96,0.78-1.75,1.75-1.75c0.96,0,1.75,0.78,1.75,1.75 C123.4,95.49,122.61,96.28,121.65,96.28z M121.65,93.34c-0.66,0-1.19,0.53-1.19,1.19s0.53,1.19,1.19,1.19 s1.19-0.53,1.19-1.19S122.31,93.34,121.65,93.34z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M128.77,96.28c-0.96,0-1.75-0.78-1.75-1.75c0-0.96,0.78-1.75,1.75-1.75c0.96,0,1.75,0.78,1.75,1.75 C130.52,95.49,129.73,96.28,128.77,96.28z M128.77,93.34c-0.66,0-1.19,0.53-1.19,1.19s0.53,1.19,1.19,1.19 s1.19-0.53,1.19-1.19S129.43,93.34,128.77,93.34z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M181.18,416.03L181.18,416.03c-0.5-0.01-0.9-0.44-0.87-0.94c0.11-2.19,0.49-7.95,1.68-13.66 c2.09-10.04,5.59-15.14,10.39-15.14c4.81,0,8.22,5.1,10.13,15.15c1.08,5.71,1.36,11.47,1.43,13.66 c0.02,0.5-0.39,0.92-0.89,0.92l0,0c-0.49,0-0.89-0.38-0.91-0.88c-0.2-8.31-2.24-27.06-9.76-27.06 c-7.54,0-9.93,18.76-10.28,27.08C182.08,415.66,181.67,416.04,181.18,416.03z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "223.25,485.18 158.07,485.18 167.05,412.65 214.27,412.65  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "219.95,485.18 154.77,485.18 163.75,412.65 210.97,412.65  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "187.36,461.31 196.74,466.24 194.95,455.8 202.54,448.4 192.05,446.88 187.36,437.38  182.67,446.88 172.19,448.4 179.77,455.8 177.98,466.24  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 176.99,
    cy: 416.29,
    r: 2.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 199.77,
    cy: 416.29,
    r: 2.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M177.04,416.03L177.04,416.03c-0.52-0.01-0.93-0.45-0.9-0.97c0.11-2.26,0.51-8.22,1.74-14.13 c2.16-10.38,5.78-15.65,10.75-15.65c4.98,0,8.5,5.27,10.47,15.67c1.12,5.9,1.41,11.86,1.48,14.13 c0.02,0.52-0.4,0.95-0.92,0.96l0,0c-0.51,0-0.92-0.4-0.94-0.9c-0.21-8.59-2.31-27.98-10.1-27.98c-7.8,0-10.26,19.4-10.63,28 C177.98,415.65,177.55,416.04,177.04,416.03z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M130.08,406.63L130.08,406.63c-0.57-0.02-1.02-0.5-0.99-1.07c0.12-2.48,0.56-9.03,1.91-15.52 c2.38-11.41,6.35-17.19,11.81-17.19c5.47,0,9.34,5.79,11.51,17.21c1.23,6.48,1.55,13.03,1.62,15.52 c0.02,0.57-0.44,1.05-1.01,1.05l0,0c-0.56,0.01-1.02-0.44-1.03-0.99c-0.23-9.44-2.54-30.73-11.09-30.73 c-8.56,0-11.27,21.31-11.68,30.75C131.11,406.22,130.64,406.65,130.08,406.63z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "177.86,485.18 103.83,485.18 114.03,402.8 167.66,402.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "174.11,485.18 100.09,485.18 110.28,402.8 163.92,402.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M139.46,464.14c-0.01,0-0.03,0-0.04,0l0,0h-0.13c-4.61-0.01-8.94-1.82-12.19-5.08 c-3.25-3.27-5.04-7.61-5.03-12.22v-0.13c0.02-9.5,7.76-17.22,17.26-17.22c0.01,0,0.03,0,0.04,0h0.13 c9.52,0.02,17.25,7.78,17.22,17.3v0.13c-0.01,4.61-1.82,8.94-5.08,12.19C148.38,462.35,144.05,464.14,139.46,464.14z  M139.42,462.96c0.01,0,0.03,0,0.04,0c4.28,0,8.31-1.66,11.34-4.68c3.04-3.03,4.73-7.07,4.74-11.36v-0.13 c0.02-8.87-7.18-16.1-16.05-16.12h-0.13c-0.01,0-0.02,0-0.04,0c-8.85,0-16.06,7.19-16.08,16.05v0.13 c-0.01,4.3,1.65,8.34,4.68,11.38c3.03,3.04,7.07,4.73,11.36,4.74L139.42,462.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M139.69,458.31L139.69,458.31c-0.16,0-0.31-0.06-0.42-0.17l-8.35-8.39c-1.29-1.3-2-3.03-2-4.88 s0.72-3.57,2.02-4.87c1.15-1.14,2.6-1.69,4.09-1.54c1.69,0.17,3.34,1.21,4.7,2.97c1.37-1.75,3.02-2.78,4.72-2.94 c1.49-0.14,2.94,0.41,4.08,1.56c1.29,1.3,2,3.03,2,4.88s-0.72,3.58-2.02,4.87l-8.39,8.35 C140,458.24,139.85,458.31,139.69,458.31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 125.32,
    cy: 406.93,
    r: 2.53
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M153.72,406.93c0,1.4-1.13,2.53-2.53,2.53s-2.53-1.13-2.53-2.53s1.13-2.53,2.53-2.53 S153.72,405.53,153.72,406.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M125.38,406.63L125.38,406.63c-0.59-0.02-1.05-0.51-1.02-1.11c0.13-2.57,0.58-9.34,1.98-16.04 c2.46-11.79,6.56-17.78,12.21-17.78s9.66,5.99,11.9,17.79c1.27,6.7,1.6,13.48,1.68,16.04c0.02,0.59-0.45,1.08-1.04,1.09l0,0 c-0.58,0.01-1.05-0.45-1.06-1.03c-0.24-9.76-2.63-31.78-11.47-31.78c-8.85,0-11.66,22.03-12.08,31.8 C126.44,406.2,125.96,406.65,125.38,406.63z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M433.42,85.04h-0.01l-5.24-0.15c-0.12,0-0.24-0.06-0.32-0.14c-0.08-0.09-0.13-0.21-0.13-0.33l0.1-3.51 c-2.2-0.23-4.42-0.74-6.3-1.45c-1.14-0.42-2.13-0.91-2.96-1.46c-0.19-0.13-0.26-0.37-0.16-0.58l3-6.31 c0.06-0.12,0.16-0.21,0.29-0.24c0.13-0.04,0.26-0.02,0.37,0.05c1.48,0.93,3.31,1.69,5.17,2.12c1.08,0.26,2.12,0.4,3.11,0.43 c1.13,0.03,1.95-0.06,2.44-0.26c0.43-0.18,0.5-0.4,0.5-0.61c0.02-0.75-1.57-1.2-3.35-1.63l-0.63-0.15 c-2.02-0.48-4.32-1.03-6.25-2.13c-1.43-0.82-2.43-1.82-3.07-3.05c-0.56-1.08-0.83-2.35-0.79-3.77c0.13-4.64,3.72-7.96,9.39-8.72 l0.1-3.65c0-0.12,0.06-0.24,0.14-0.32c0.09-0.08,0.21-0.13,0.33-0.13l5.24,0.15c0.25,0.01,0.45,0.22,0.45,0.47l-0.1,3.56 c0.87,0.12,1.72,0.29,2.53,0.49c1.79,0.45,3.37,1.08,4.71,1.88c0.2,0.12,0.28,0.37,0.18,0.58l-2.82,6.28 c-0.05,0.12-0.15,0.21-0.27,0.25s-0.25,0.03-0.37-0.03c-0.17-0.09-0.34-0.18-0.51-0.27c-2.25-1.14-4.42-1.75-6.47-1.81 c-0.15,0-0.29-0.01-0.43,0c-1.14,0.01-2.5,0.21-2.52,1.1c0,0.13,0.03,0.31,0.35,0.53c0.66,0.46,2,0.77,3.56,1.12 c1.01,0.23,2.16,0.49,3.28,0.84c2.07,0.64,4.97,1.81,6.25,4.55l0,0c0.47,1.01,0.69,2.18,0.66,3.47 c-0.13,4.45-3.53,7.74-8.91,8.64l-0.11,3.74c0,0.12-0.06,0.24-0.14,0.32C433.65,85,433.54,85.04,433.42,85.04z M428.65,83.99 l4.32,0.12l0.1-3.66c0.01-0.22,0.17-0.41,0.39-0.44c5.21-0.76,8.38-3.68,8.5-7.82c0.03-1.14-0.16-2.17-0.57-3.05l0,0 c-0.85-1.83-2.66-3.12-5.69-4.06c-1.08-0.34-2.21-0.59-3.21-0.82c-1.65-0.38-3.08-0.71-3.88-1.27 c-0.51-0.35-0.76-0.79-0.75-1.31c0.03-0.89,0.64-1.96,3.43-1.99c0.15,0,0.31,0,0.47,0.01c2.18,0.06,4.49,0.7,6.86,1.91 c0.03,0.02,0.06,0.03,0.1,0.05l2.45-5.45c-1.18-0.66-2.56-1.19-4.11-1.58c-0.91-0.23-1.86-0.41-2.84-0.53 c-0.24-0.03-0.41-0.23-0.4-0.47l0.1-3.52l-4.32-0.12l-0.1,3.59c-0.01,0.23-0.18,0.42-0.41,0.44c-5.5,0.61-8.85,3.56-8.97,7.88 c-0.04,1.26,0.2,2.38,0.69,3.32c0.55,1.07,1.44,1.95,2.71,2.68c1.81,1.04,4.04,1.57,6,2.04l0.63,0.15 c1.92,0.46,4.1,0.99,4.06,2.55c-0.01,0.45-0.21,1.07-1.07,1.43c-0.62,0.26-1.55,0.37-2.82,0.33c-1.05-0.03-2.16-0.18-3.3-0.45 c-1.77-0.42-3.53-1.11-5.01-1.97l-2.61,5.48c0.7,0.42,1.52,0.81,2.44,1.15c1.93,0.73,4.23,1.23,6.48,1.43 c0.24,0.02,0.43,0.23,0.42,0.47L428.65,83.99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M179.42,37.19L179.42,37.19c0,0.29,0.24,0.53,0.53,0.53h130.33c0.29,0,0.53-0.24,0.53-0.53l0,0 c0-0.29-0.24-0.53-0.53-0.53H179.95C179.65,36.66,179.42,36.9,179.42,37.19z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M126.89,243.99c0-0.29-0.24-0.53-0.53-0.53H82.18c-0.26,0-0.51,0.18-0.55,0.44 c-0.05,0.33,0.2,0.62,0.52,0.62h44.2C126.65,244.52,126.89,244.28,126.89,243.99L126.89,243.99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M104.14,54.16c-0.07,0-0.14-0.01-0.2-0.04l-7.07-3.13c-1.98,0.82-4.09,1.23-6.27,1.23h-0.17 c-4.4-0.01-8.54-1.74-11.65-4.86s-4.81-7.27-4.8-11.67v-0.13C74,26.48,81.4,19.1,90.48,19.1h0.17 c9.1,0.02,16.48,7.44,16.46,16.53v0.13l0,0c-0.01,3.83-1.28,7.41-3.68,10.35l1.22,7.48c0.03,0.18-0.04,0.36-0.19,0.47 C104.36,54.12,104.25,54.16,104.14,54.16z M96.87,49.94c0.07,0,0.14,0.01,0.2,0.04l6.43,2.85l-1.11-6.79 c-0.02-0.14,0.02-0.29,0.11-0.4c2.34-2.79,3.59-6.21,3.6-9.89v-0.13c0.02-8.55-6.92-15.52-15.47-15.54h-0.16 c-8.53,0-15.48,6.94-15.5,15.47v0.13c-0.01,4.14,1.59,8.04,4.51,10.97c2.92,2.93,6.81,4.56,10.95,4.57h0.17 c2.11,0,4.16-0.41,6.08-1.23C96.74,49.96,96.81,49.94,96.87,49.94z M106.6,35.75L106.6,35.75L106.6,35.75z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M90.83,47.09L90.83,47.09c-0.16,0-0.31-0.06-0.42-0.17l-8.31-8.35c-1.29-1.29-1.99-3.02-1.99-4.85 c0-1.84,0.72-3.56,2.01-4.84c1.14-1.14,2.58-1.68,4.07-1.53c1.68,0.17,3.32,1.21,4.68,2.95c1.36-1.74,3.01-2.77,4.69-2.93 c1.48-0.14,2.92,0.41,4.06,1.55c1.29,1.29,1.99,3.02,1.99,4.85c0,1.84-0.72,3.56-2.01,4.84l-8.35,8.31 C91.14,47.03,90.99,47.09,90.83,47.09z M85.71,28.49c-1.01,0-1.95,0.42-2.75,1.22c-1.07,1.07-1.66,2.49-1.66,4.01 s0.58,2.95,1.65,4.02l7.9,7.93l7.93-7.9c1.07-1.07,1.66-2.49,1.67-4.02l0,0c0-1.52-0.58-2.95-1.65-4.02 c-0.9-0.9-1.97-1.32-3.12-1.21c-1.53,0.14-3.07,1.24-4.32,3.09c-0.11,0.16-0.29,0.26-0.49,0.26l0,0c-0.2,0-0.38-0.1-0.49-0.26 c-1.24-1.85-2.77-2.96-4.3-3.11C85.95,28.49,85.83,28.49,85.71,28.49z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.89,210.37c-3.08,0-5.58,2.51-5.58,5.58c0,3.08,2.5,5.58,5.58,5.58s5.58-2.5,5.58-5.58 C118.47,212.88,115.96,210.37,112.89,210.37z M112.89,220.48c-2.5,0-4.53-2.03-4.53-4.53s2.03-4.53,4.53-4.53 s4.53,2.03,4.53,4.53S115.38,220.48,112.89,220.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M452.39,95.38c-3.08,0-5.58,2.51-5.58,5.58c0,3.08,2.5,5.58,5.58,5.58s5.58-2.5,5.58-5.58 C457.97,97.89,455.47,95.38,452.39,95.38z M452.39,105.5c-2.5,0-4.53-2.03-4.53-4.53s2.03-4.53,4.53-4.53s4.53,2.03,4.53,4.53 S454.89,105.5,452.39,105.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommercesolution);
export default __webpack_public_path__ + "static/media/ecommercesolution.194f2b01d5ea1e691bbbf9d8b0e78126.svg";
export { ForwardRef as ReactComponent };